<template>
  <div class="trend-chart-container">
    <div ref="chartRef" class="chart-container"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getConversationTrend } from '@/api/dashboard/index.js'

export default {
  name: 'AdminConversationTrendChart',
  props: {
    tenantId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      chartInstance: null,
      loading: false
    }
  },
  mounted() {
    this.initChart()
    this.fetchData()
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chartRef)
      // 窗口自适应
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    async fetchData() {
      if (!this.tenantId) {
        console.warn('tenantId 为空，无法获取咨询量趋势数据')
        return
      }
      
      this.loading = true
      try {
        const response = await getConversationTrend(this.tenantId)
        if (response.data.code === 200) {
          const data = response.data.data
          this.renderChart(data)
        } else {
          console.error('获取咨询量趋势失败:', response.data.message)
        }
      } catch (error) {
        console.error('获取咨询量趋势异常:', error)
      } finally {
        this.loading = false
      }
    },
    renderChart(data) {
      if (!this.chartInstance) return
      
      const dates = data.map(item => item.date)
      const counts = data.map(item => item.count)
      
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            const param = params[0]
            return `<div style="font-weight:bold;">${param.axisValue}</div>
                    <div>咨询量：<span style="color:#057FDB;font-weight:bold;">${param.value}</span> 次</div>`
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          top: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: { lineStyle: { color: '#e8e8e8' } },
          axisLabel: {
            color: '#666',
            fontSize: 12,
            // 格式化日期显示
            formatter: (value) => {
              const parts = value.split('-')
              return `${parts[1]}月${parts[2]}日`
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: { color: '#f0f0f0', type: 'dashed' }
          },
          axisLabel: {
            color: '#666',
            fontSize: 12
          }
        },
        series: [
          {
            name: '咨询量',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              color: '#057FDB',
              width: 3
            },
            itemStyle: {
              color: '#057FDB'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(5, 127, 219, 0.3)' },
                  { offset: 1, color: 'rgba(5, 127, 219, 0.05)' }
                ]
              }
            },
            data: counts,
            // 显示数据标签
            label: {
              show: true,
              position: 'top',
              color: '#057FDB',
              fontSize: 12,
              fontWeight: 500
            }
          }
        ],
        // 动画效果
        animationDuration: 1000,
        animationEasing: 'cubicOut'
      }
      
      this.chartInstance.setOption(option)
    },
    // 外部调用刷新
    refresh() {
      this.fetchData()
    }
  },
  watch: {
    tenantId: {
      handler(newVal) {
        if (newVal) {
          this.fetchData()
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.trend-chart-container {
  width: 100%;
  height: 100%;
}

.chart-container {
  width: 100%;
  height: 250px;
}
</style>